import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { User } from 'src/api';
import { AuthorizeUser } from 'src/components/Authorization';
import { Mixpanel } from '../../Mixpanel';

import './enroll-btn.scss';

class EnrollBtn extends Component {
  constructor() {
    super()
    this.state = {
      waitingForEnroll: false,
      enrolled: false,
      enrolledUsers: 0,
    };
  }

  componentDidMount() {
    this.setState({
      enrolled: this.isEnrolled(),
      enrolledUsers: this.props.hackathon.marked_users.length,
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.username !== prevProps.username) {
      this.setState({
        enrolled: this.isEnrolled(),
      })
    }
  }
  
  /**
   * Checking whether user is enrolling or unenrolling.
   * @return {Bool}
   */
  isUserEnrolling = () => {
    // Checking username, because otherwise if we try to enroll not as
    // logged user we will unenroll him
    return !this.state.enrolled && this.props.username;
  }

  toggleEnroll = (e) => {
    Mixpanel.track(this.props.parent, {'Button': 'Enroll'})
    e.preventDefault();
    e.stopPropagation();
    const isUserEnrolling = this.isUserEnrolling();
    AuthorizeUser()
      .then(() => this.enrollUserToEvent(isUserEnrolling));
    // .catch(() => this.onEnrollError({ detail: 'Not Authorized!' }));
  }

  /**
   * @param {Boolean} isUserEnrolling - whether we enroll(true) or unenroll user(false)
   */
  enrollUserToEvent = (isUserEnrolling) => {
    this.setState({ waitingForEnroll: true },
      () => {
        const request = isUserEnrolling ? User.enrollToEvent : User.unEnrollFromEvent;
        request((this.props.hackathon.id))
          .then(() => this.onEnrollToggleSuccess(isUserEnrolling))
          .catch((err) => this.onEnrollToggleError(err));
      }
    )
  }

  isEnrolled = () => {
    return this.props.hackathon.marked_users.findIndex((user) => user.username === this.props.username) > -1;
  }

  onEnrollToggleError = (error) => {
    console.error(`Wasnt able to ${this.state.enrolled ? 'unenroll' : 'enroll'}`, error);
    const errorMsg = error.detail ? error.detail : error;
    toast.error(errorMsg);
    this.setState({
      waitingForEnroll: false,
    })
  }

  onEnrollToggleSuccess = (isUserEnrolling) => {
    const alreadyEnrolled = this.isEnrolled()
    if (isUserEnrolling && !alreadyEnrolled) {
      this.props.hackathon.marked_users.push({ username: this.props.username, email: this.props.email });
    } else if (!isUserEnrolling && alreadyEnrolled) {
      const usernamePosition = this.props.hackathon.marked_users.findIndex((user) => user.username === this.props.username);
      if (usernamePosition > -1) {
        this.props.hackathon.marked_users.splice(usernamePosition, 1);
      } 
    }
    
    this.setState({
      waitingForEnroll: false,
      enrolledUsers: this.props.hackathon.marked_users.length,
      enrolled: this.isEnrolled(),
    });
  }

  render() {
    return (
      <div className={`hackathon-enroll ${this.state.enrolled ? 'enrolled' : ''}`} onClick={this.toggleEnroll}>
        <span role='img'>{this.state.enrolled ? 'Я пойду' : '🏃'}</span> {this.state.enrolledUsers}
      </div>
    );
  }
}

EnrollBtn.propTypes = {
  username: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  hackathon: PropTypes.object.isRequired,
  parent: PropTypes.string.isRequired,
}

function mapStateToProps(state) {
  return {
    username: state.user.username,
    email: state.user.email,
  };
}

export default connect(mapStateToProps, {})(EnrollBtn);


// WEBPACK FOOTER //
// ./src/components/Event/EnrollBtn/index.js